export class FilesInTransfer {
  constructor() {
    this.inTransfer = false
    this.count = 0
    this.actual = 0
    this.files = []
  }
  init(data) {
    this.inTransfer = data.inTransfer
    this.count = data.count
    this.actual = data.actual
    this.files = data.files
  }
  update(data) {
    this.inTransfer =
      data.inTransfer !== undefined ? data.inTransfer : this.inTransfer
    this.count = data.count !== undefined ? data.count : this.count
    this.actual = data.actual !== undefined ? data.actual : this.actual
    this.files.sort((a, b) => {
      if (a.error < b.error || a.canceled < b.canceled) return 1
      if (a.error > b.error || a.canceled > b.canceled) return -1
      return 0
    })
  }
  increaseActual() {
    this.actual++
  }
}
